<template>
  <el-cascader
    v-model="selectedRegions"
    :options="regionOptions"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    class="region-select"
    @change="handleChange"
  />
</template>

<script>
import { regionData, codeToText } from 'element-china-area-data'

export default {
  name: 'RegionSelect',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '选择您的所在地'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedRegions: this.value,
      regionOptions: regionData,
      cascaderProps: {
        expandTrigger: 'hover',
        value: 'code',
        label: 'label'
      }
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.selectedRegions = newVal
      },
      immediate: true
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('input', value)
      // 将区域代码转换为文本
      const regionNames = value.map(code => codeToText[code])
      this.$emit('change', {
        codes: value,
        names: regionNames
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.region-select {
  width: 100%;
  
  ::v-deep .el-input {
    .el-input__inner {
      background: #ffffff;
      border-radius: 8px;
      border: none;
      height: 40px;
      padding: 0 11px;
      font-size: 14px;
      color: #1D2129;

      &::placeholder {
        color: #4E5969;
      }

      &:focus {
        box-shadow: none;
      }
    }

    .el-input__suffix {
      right: 11px;
      .el-input__suffix-inner {
        .el-icon-arrow-down {
          font-size: 12px;
          color: #4E5969;
        }
      }
    }
  }

  /* 下拉面板样式 */
  ::v-deep .el-cascader__dropdown {
    .el-cascader-panel {
      .el-cascader-menu {
        .el-cascader-menu__item {
          &:hover, &.is-active {
            color: #000;
            background: #F2F3F5;
          }
        }
      }
    }
  }
}
</style> 